































import { Intervention } from "../../models/Intervention";

export default {
    name: "InterventionAnomalies",
    props: {
        intervention: Intervention,
    },
    data() {
        return {
            AnomalyList: Intervention.Anomaly,
            EAnomaly: Intervention.EAnomaly,
        };
    },
    methods: {
        round(value: number): number {
            return _.round(value, 2);
        },
        showMap(anomaly: Intervention.EAnomaly) {
            let coords = null;
            if (
                !this.intervention.client ||
                !this.intervention.client.adresse ||
                !this.intervention.client.adresse.coord
            ) {
                return;
            }
            let destinationCoords = this.intervention.client.adresse.coord;
            if (anomaly === Intervention.EAnomaly.DistancePointageDebut) {
                coords = this.intervention.coord_debut_intervention;
            } else if (anomaly === Intervention.EAnomaly.DistancePointageFin) {
                coords = this.intervention.coord_fin_intervention;
            }
            if (coords) {
                let pointage = coords.lat + "," + coords.lng;
                let destination =
                    destinationCoords.lat + "," + destinationCoords.lng;
                let url =
                    "https://www.google.com/maps?f=d&saddr=" +
                    pointage +
                    "&daddr=" +
                    destination +
                    "&dirflg=d";
                window.open(url, "_blank");
            }
        },
    },
};
